import { instanceV2 } from '@/api/instance';
import type { PlusCourse } from '@/types';
import type { PlusLiteCourse } from '@/types';

import type {
  DiscountCode,
  EarlybirdDiscountResponseDto,
  EnrolledDiscountCodesResponseDto,
} from './discount-policy.dto';
import type { ValidateDiscountCodeRequestDto } from './discount-policy.dto';

export async function getEarlybirdDiscount(
  courseName: PlusCourse | PlusLiteCourse | undefined,
) {
  return await instanceV2.get<EarlybirdDiscountResponseDto>(
    `/v3/discount-policies/courses/${courseName}/early-bird`,
  );
}

export async function validateDiscountCode(
  body: ValidateDiscountCodeRequestDto,
) {
  return await instanceV2.post<DiscountCode>(
    '/v3/discount-codes/validate',
    body,
  );
}

export async function getEnrolledDiscountCodes(onlineUserId: string) {
  return await instanceV2.get<EnrolledDiscountCodesResponseDto>(
    `/v3/discount-codes/enrolled/${onlineUserId}`,
  );
}
